import { render } from "./AppLayout.vue?vue&type=template&id=5663af57"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/AppLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5663af57"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5663af57', __exports__)) {
    console.log('reload')
    api.reload('5663af57', __exports__)
  }
  
  module.hot.accept("./AppLayout.vue?vue&type=template&id=5663af57", () => {
    console.log('re-render')
    api.rerender('5663af57', render)
  })

}


export default __exports__